import { render, staticRenderFns } from "./physioPowerList.vue?vue&type=template&id=a4bbfcfc&scoped=true"
import script from "./physioPowerList.vue?vue&type=script&lang=js"
export * from "./physioPowerList.vue?vue&type=script&lang=js"
import style0 from "./physioPowerList.vue?vue&type=style&index=0&id=a4bbfcfc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4bbfcfc",
  null
  
)

export default component.exports